<template>
  <b-container>
    <slot v-if="initialized"></slot>
    <!-- <pre class="language-json">waypoints:<code>{{ waypoints  }}</code></pre> -->
  </b-container>
</template>
    
<script>
export default {
  name: "LeafletRoute",
  props: {
    latitude: Number,
    longitude: Number,
  },
  components: {},
  mixins: [],
  data() {
    return {
      routingControl: null,
      initialized: false,
      myTimeout: null,
      waypoints: [],
    };
  },
  inject: ["getMap"],
  provide() {
    return {
      addWaypoint: (location) => this.addWaypoint(location),
      getMap: () => this.getMap,
      getRoutingControl: () => this.routingControl,
      setWaypointLocation: (index, location) =>
        this.setWaypointLocation(index, location),
    };
  },
  methods: {
    addWaypoint(location) {
      if (this.myTimeout) {
        clearTimeout(this.myTimeout);
        this.myTimeout = null;
      }
      let waypoint = {
        index: this.waypoints.length,
        location: location,
      };
      this.waypoints.push(waypoint);
      this.myTimeout = setTimeout(() => {
        this.routingControl.setWaypoints(this.waypoints.map((x) => x.location));
      }, 500);
      return waypoint;
    },
    calculateDirections(e) {
      var route = e.routes[0];
      const directions = [];
      // Create direction objects
      for (let i = 1; i < route.waypointIndices.length; i++) {
        const startIndex = route.waypointIndices[i - 1];
        const endIndex = route.waypointIndices[i];
        let direction = {
          startWaypoint: {
            index: startIndex,
            latitude: route.coordinates[startIndex].lat,
            longitude: route.coordinates[startIndex].lng,
          },
          endWaypoint: {
            index: endIndex,
            latitude: route.coordinates[endIndex].lat,
            longitude: route.coordinates[endIndex].lng,
          },
          summary: {
            distance: 0.0,
            time: 0.0,
          },
        };
        directions.push(direction);
      }
      // Calculate distance and time
      for (let direction of directions) {
        const instructions = route.instructions.filter(
          (ins) =>
            ins.index >= direction.startWaypoint.index &&
            ins.index <= direction.endWaypoint.index
        );
        for (let ins of instructions) {
          direction.summary.distance += ins.distance;
          direction.summary.time += ins.time;
        }
        direction.summary.distance = Math.round(direction.summary.distance);
        direction.summary.time = Math.round(direction.summary.time);
        // Math.round(num * 100) / 100
        // Math.round((num + Number.EPSILON) * 100) / 100
      }
      this.$emit("calculateDirections", directions);
    },
    createWaypointMarker(i, waypoint, n) {
      if (i == 0) {
        return L.marker(waypoint.latLng, {
          draggable: false,
          icon: L.divIcon({
            className: "marker-pin-circle-begin",
            html: `<div class="marker-pin-label"><b>${i + 1}</b></div>`,
            iconSize: [21, 21],
          }),
        });
      } else if (i == n - 1) {
        return L.marker(waypoint.latLng, {
          draggable: false,
          icon: L.divIcon({
            className: "marker-pin-circle-end",
            html: `<div class="marker-pin-label"><b>${i + 1}</b></div>`,
            iconSize: [21, 21],
          }),
        });
      } else {
        return L.marker(waypoint.latLng, {
          draggable: false,
          icon: L.divIcon({
            className: "marker-pin-circle-normal",
            html: `<div class="marker-pin-label"><b>${i + 1}</b></div>`,
            iconSize: [21, 21],
          }),
        });
      }
    },
    destroy() {
      //   try {
      //     if (infobox) {
      //       let map = this.getMap();
      //       if (map) {
      //         infobox.setMap(null);
      //       }
      //     }
      //   } finally {
      //     this.setItem(null);
      //   }
    },
    getWaypoint(latitude, longitude) {
      let waypoint = null;
      console.log("LeafletRoute.getWaypoint");
      console.log(this.waypoints);
      this.waypoints.forEach((point) => {
        if (point.location.lat == latitude && point.location.lng == longitude)
          waypoint = point;
      });
      return waypoint;
    },
    mapFitBounds(e) {
      let routeBounds = [];
      for (let waypoint of e.waypoints) {
        routeBounds.push([waypoint.latLng.lat, waypoint.latLng.lat]);
      }
      const map = this.getMap();
      map.fitBounds(routeBounds);
    },
    setWaypointLocation(index, location) {
      if (this.myTimeout) {
        clearTimeout(this.myTimeout);
        this.myTimeout = null;
      }
      this.waypoints[index].location = location;
      this.myTimeout = setTimeout(() => {
        this.routingControl.setWaypoints(this.waypoints.map((x) => x.location));
      }, 500);
    },
    forceUpdate() {
      this.initialized = false;
      this.waypoints.splice(0, this.waypoints.length);
      this.myTimeout = setTimeout(() => {
        this.initialized = true;
      }, 500);
    },
    render() {
      const map = this.getMap();
      this.routingControl = L.Routing.control({
        addWaypoints: true,
        waypoints: [],
        createMarker: (i, waypoint, n) =>
          this.createWaypointMarker(i, waypoint, n),
      })
        .on("routesfound", (e) => {
          this.calculateDirections(e);
          this.mapFitBounds(e);
        })
        .addTo(map);
      this.initialized = true;
    },
  },
  beforeDestroy() {
    this.destroy();
  },
  mounted() {
    this.render();
  },
};
</script>

<style>
.leaflet-routing-container {
  display: none;
}

.marker-pin-circle-begin {
  border-radius: 50% 50% 50% 50%;
  background: green;
  color: white;
  text-align: center;
}

.marker-pin-circle-end {
  border-radius: 50% 50% 50% 50%;
  background: red;
  color: white;
  text-align: center;
}

.marker-pin-circle-normal {
  border-radius: 50% 50% 50% 50%;
  background: blue;
  color: white;
  text-align: center;
}

.marker-pin-label {
  margin-top: 1px;
}
</style>
    
    